module.exports = __webpack_public_path__ + "static/media/gazer.b250c4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/commanders/gazer.png
// module id = 2063
// module chunks = 0